import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-project-location-map-plan',
  templateUrl: './project-location-map-plan.component.html',
  styleUrls: ['./project-location-map-plan.component.css']
})
export class ProjectLocationMapPlanComponent implements OnInit {
  idProject: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.idProject = this.route.snapshot.paramMap.get('idProject');
  }

}
